import React from "react";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { Box, Typography } from "@mui/material";
import { FONT_SIZE } from "../../constants/fontSizes";
import { useIsDesktop } from "./hooks/useIsDesktop";

/**
 * 共通の案内バナー
 */
export default function NoticeBanner({ text }) {
  const isDesktop = useIsDesktop();
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: 1,
        borderRadius: "999px",

        width: isDesktop ? "auto" : "100%",
        justifyContent: "flex-start",
        minHeight: isDesktop ? 24 : 32,
        pl: "4px",
        pr: isDesktop ? "4px" : "6px",
        py: isDesktop ? "1.5px" : "3px",

        bgcolor: "#FFFFFF",
        color: "#666",

        // 吹き出し
        "&::after": {
          content: '""',
          position: "absolute",

          // スマホ：上中央
          top: isDesktop ? "50%" : -5,
          left: isDesktop ? "auto" : "50%",
          right: isDesktop ? -3 : "auto",
          transform: isDesktop ? "translateY(-50%)" : "translateX(-50%)",

          width: 0,
          height: 0,

          // スマホ：上向き,PC：右向き
          borderTop: isDesktop ? "4px solid transparent" : "none",
          borderRight: isDesktop ? "none" : "6px solid transparent",
          borderBottom: isDesktop
            ? "4px solid transparent"
            : "6px solid #FFFFFF",
          borderLeft: isDesktop ? "4px solid #FFFFFF" : "6px solid transparent",
        },
      }}
    >
      {/* 黄色アイコン */}
      <Box
        sx={{
          width: isDesktop ? 20 : 28,
          height: isDesktop ? 20 : 28,
          borderRadius: "50%",
          bgcolor: "#FFD400",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <PriorityHighIcon
          sx={{
            color: "#000",
            fontSize: isDesktop ? FONT_SIZE.BASE : FONT_SIZE.LG,
            fontWeight: "bold",
          }}
        />
      </Box>

      <Typography
        sx={{
          flex: 1,
          textAlign: "center",
          fontSize: FONT_SIZE.XXS,
          lineHeight: 1.2,
          whiteSpace: isDesktop ? "nowrap" : "pre-line",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
